import { html } from 'lit';
const ShareiOs =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M11.47 1.47a.75.75 0 0 1 1.06 0l4 4a.75.75 0 0 1-1.06 1.06l-2.72-2.72V15a.75.75 0 0 1-1.5 0V3.81L8.53 6.53a.75.75 0 0 1-1.06-1.06zM4 11.25a.75.75 0 0 1 .75.75v8A1.25 1.25 0 0 0 6 21.25h12A1.25 1.25 0 0 0 19.25 20v-8a.75.75 0 0 1 1.5 0v8A2.75 2.75 0 0 1 18 22.75H6A2.75 2.75 0 0 1 3.25 20v-8a.75.75 0 0 1 .75-.75" clip-rule="evenodd"/>
  </svg>
`;
export default ShareiOs;
